import { BsArrowUp } from "react-icons/bs";

export default function HomeCallToAction() {
  return (
    <section className="max-w-6xl mx-auto w-full px-4 sm:px-5 py-16">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-purple-700 to-indigo-600 px-6 py-12 md:py-16 text-center text-white">
        <div className="pointer-events-none absolute -top-16 -right-16 h-56 w-56 rounded-full bg-white/10" aria-hidden="true" />
        <div className="pointer-events-none absolute -bottom-20 -left-10 h-48 w-48 rounded-full bg-fuchsia-400/20" aria-hidden="true" />
        <h2 className="relative text-3xl md:text-4xl mb-4">Ready to Send Your Parcel?</h2>
        <p className="relative text-lg md:text-xl mb-8 text-white/90">Get started in minutes with our simple booking process</p>
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="relative inline-flex items-center gap-2 bg-white text-purple-700 px-8 py-4 rounded-full font-semibold text-lg hover:bg-purple-50 transition-colors shadow-lg"
        >
          Get Started Now <BsArrowUp aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}
